angular.module('qkr').factory('partnerService', ($http, appConfig, $log, $routeParams) => ({

    listPartners() {
        return $http.get(appConfig.apiUrl + 'partner/list', {withCredentials: true})
            .then(response => response.data);
    },

    listPosPartners() {
        return $http.get(appConfig.apiUrl + 'partner/listForPos', {withCredentials: true})
            .then(response => response.data);
    },

    getPartner(partnerId) {
        return $http.get(appConfig.apiUrl + 'partner/get/' + partnerId, {withCredentials: true})
            .then(response => response.data);
    },

    getCurrentPartner() {
        if ($routeParams.partnerId) {
            return this.getPartner($routeParams.partnerId)
        } else {
            return this.listPartners().then(partners => partners[0]);
        }
    },

    create(partnerName, allowedCreateMerchant, allowedBusinessCategories, isPosType, createUsersInMasterPass) {
        return $http.post(appConfig.apiUrl + 'partner/create',
            {
                name: partnerName,
				allowedCreateMerchant: allowedCreateMerchant,
				allowedBusinessCategories: allowedBusinessCategories,
                isPosType: isPosType,
                createUsersInMasterPass: createUsersInMasterPass
            })
            .then(response => response.data);
    },

    update(partnerId, allowedCreateMerchant, allowedBusinessCategories) {

        return $http.post(appConfig.apiUrl + 'partner/update',
            {
                id: partnerId,
				allowedCreateMerchant: allowedCreateMerchant,
				allowedBusinessCategories: allowedBusinessCategories
            })
            .then(response => response.data);
    }

}));



// WEBPACK FOOTER //
// ./src/services/partner.services.js